export const contactsData = {
    email: 'talhashinwari7474@gmail.com',
    phone: '+923034515043',
    address: 'Phase-4, Bahria, Rawalpindi Pakistan',

    sheetAPI: ''
}